module.exports = __webpack_public_path__ + "img/143.caa618db.jpg";